module.exports = __webpack_public_path__ + "images/emoji/skull.6487feaeefce5dcd15ba.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/skull.png
// module id = rPo7
// module chunks = 13